const HOST_PATTERN =
  /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/;

export const getWhitelistedDomainError = (value: string): string | null => {
  const raw = value.trim().toLowerCase();

  if (!raw) {
    return "Enter a valid domain name.";
  }
  if (raw.includes("@")) {
    return "Enter a domain host, not an email address.";
  }
  if (raw.includes("://") || raw.includes("/")) {
    return "Enter a domain host without a path or protocol.";
  }
  if (!HOST_PATTERN.test(raw)) {
    return "Enter a valid domain name.";
  }

  return null;
};
